<template>
  <div>
    <a
      v-for="(dc, index) in dcList"
      :key="index"
      class="btn btn-app"
      :href="url + '' + dc.Id"
    >
      DC Recieved
      <span
        href="#"
        @click="deleteDeliveryChallan($event, dc.Id)"
        class="cross"
        data-toggle="tooltip"
        data-placement="top"
        title="Delete DC"
      >
        <i class="fas fa-times-circle"></i>
      </span>
      <i class="fas fa-shipping-fast"></i
      >{{ new Date(dc.Date) | dateFormat("DD.MMM.YYYY") }}
    </a>
    <a
      class="btn btn-app btn-add-dc"
      data-toggle="modal"
      data-target="#modal-add-dc"
      data-placement="bottom"
      title="Add DC"
      data-backdrop="static"
    >
      <i class="fas fa-plus-circle"></i> Add Delivery Challan
    </a>
  </div>
</template>

<script>
    export default {
        name: 'delivery-challan-list',
        props: ['DeliveryChallans', 'PurchaseOrderId'],
        data() {
            return {
                url: 'delivery-challan/',
                urlDeleteDeliveryChallan: '/delivery-challan/destroy/',
                dcList: null
            }
        },
        methods: {
            getDeliveryChallans() {
                axios.get('delivery-challan/all-delivery-challan/' + this.PurchaseOrderId)
                .then(response => {
                    this.dcList = response.data;
                    if(response.data.success != 1){} else {


                        Swal.fire({
                            title: 'Submitted Successfully',
                            icon: 'success',
                        })
                    }

                })
                .catch(error => {
                    this.errored = true
                })
                .finally(() => this.loader = false)
            },
            deleteDeliveryChallan(e, id){
                e.preventDefault()
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // getting items of posted purchase order
                        axios.delete(this.urlDeleteDeliveryChallan + id)
                            .then(response => {
                                this.getDeliveryChallans()
                                Swal.fire(
                                    'Deleted!',
                                    'Your file has been deleted.',
                                    'success'
                                )
                                
                            })
                    }
                })
                .catch(error => {
                    this.errored = true
                })
                .finally(() => this.loading = false)
            }
        },
        mounted () {
           this.getDeliveryChallans()
        },
    }
</script>

<style lang="scss" scoped>
.btn-app {
  font-size: 16px;
  height: 100px;
}
.btn-add-dc {
  padding: 30px;
}
.cross {
  position: absolute;
  top: 0;
  right: 0;
  color: rgb(218, 137, 137);
}
</style>
